<template>
  <div :class="['gridly-box', 'gridly-box-flex']">

    <!-- 图片上传【裁切】 -->
    <el-upload v-if="imgCropper && picList.length < picListLimit ? true : false" class="up-img-btn pull-left" ref="upload" accept="image/jpeg,image/png" action="" list-type="picture" :show-file-list="false" :limit="picListLimit" :on-exceed="handleExceed" :file-list="picList" :before-upload="beforeUpload" :on-success="uploadImgSuccess" :on-error="uploadImgError" :on-remove="handleRemove" :with-credentials="true">
      <!-- <img :src="'/static/images/upload/add.svg'" /> -->
      <i class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <upload-cropper @uploadImg="uploadImg" dialogClass="dialogBox" @CopperColse="CopperColse" :domVisible='dislogType' :imgbase="imgbase" v-if='dislogType' />
    <!-- 图片上传【不裁切】 -->
    <el-upload v-if="!imgCropper && (picList.length < picListLimit ? true : false)" class="up-img-btn pull-left" ref="upload" accept="image/jpeg,image/png" action="" :http-request="uploadImg" list-type="picture" :show-file-list="false" :limit="picListLimit" :on-exceed="handleExceed" :file-list="picList" :before-upload="beforeUpload" :on-success="uploadImgSuccess" :on-error="uploadImgError" :on-remove="handleRemove" :with-credentials="true">
      <!-- <img :src="'/static/images/upload/add.svg'" /> -->
      <i class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>

    <div :class="['pic-list-box', flexCol || '']" v-if="picList.length">
      <div class="gridly-item item" v-for="(obj, key) in picList" :key="obj.key" v-bind:data-id="obj.id" v-bind:id="'imgDivShowImageUrl' + obj.id" draggable="true" @dragstart="handleDragStart($event, obj)" @dragover.prevent="handleDragOver($event, obj)" @dragenter="handleDragEnter($event, obj)" @dragend="handleDragEnd($event, obj)">
        <div class="thumbnail" v-bind:class="[key <= 0 ? 'img-selected' : '']">
          <el-image class="card-pic" v-bind:data-id="obj.id" v-bind:src="obj.ImageUrl + '?imageView2/2/w/200'" fit="contain"></el-image>
          <a href="javascript:void(0);" class="dltImg" role="button" @click="dltImgDiv('imgDivShowImageUrl' + obj.id, 'uploadShowImageUrl', obj.id, key)">
            <img src="/static/images/upload/close.png" />
          </a>
        </div>
        <div v-if="showUrl" class="img-url" @click="copy(obj.ImageUrl)">
          <!-- {{ obj.ImageUrl }} -->
          <input type="text" v-model="obj.ImageUrl" ref="TextRef" class="text-img-url" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadCropper from "@/components/upload-cropper";
import Guid from 'guid';
var COS = require('cos-js-sdk-v5');
var cos = "", cosData = "";
export default {
  name: 'UploadImages',
  data() {
    return {
      picList: [], //图片列表
      FormData: {}, //表单提交值
      uploadUrl: process.env.VUE_APP_BASEURL + '/NewCommodity/UploadImage',//&token=+this.$store.state.ChToken
      ImagesUrl: this.$store.state.cosConfig.ImagesUrl,//图片域名地址
      picListLimit: 50,
      dragging: null,
      minImgWidth: 300,
      minImgHeight: 300,
      dislogType: false,//upload-cropper是否显示
      imgbase: '',//upload-cropper:预览图片
      showUrl: true,
    }
  },
  props: {
    uploadType: '',
    needReturn: false,//是否返回父组件图片列表
    imgCropper: false,//是否需要裁切
    Prefix: '',// /*cos文件目录*/
    flexCol: '',//flexCol:flex-col
  },
  components: {
    UploadCropper
  },
  watch: {
    picList: function (newData, oldData) {
      // console.log("uploadType", newData, oldData, this.uploadType);
      if (this.uploadType == 'small') {
        this.picListLimit = 5;
      }
    }
  },
  created: function () {
    var that = this;
    that.NewCos();
  },
  methods: {
    async copy(val) {
      try {
        await navigator.clipboard.writeText(val);
        this.$message({
          message: '复制成功',
          type: 'success'
        });
      } catch (err) {
        // this.$message('复制失败');
        console.log("复制失败", err);
      }
    },
    // 展示图上传
    beforeUpload(file) {
      var that = this;
      console.log(file);
      var isJPG = file.type === "image/jpeg" || file.type === "image/png";
      var isLt5M = file.size / (1024 * 1024 * 5) < 5;

      if (!isJPG) {
        that.$message.warning(that.$t('tips.uploadedPicType', ['JPG/PNG']));
        return false;
      }
      if (!isLt5M) {
        that.$message.warning(that.$t('tips.uploadedPicSize', ['5MB']));
        return false;
      }
      //that.$message.error('上传图片分辨率建议800*600以上!');

      var _sort = that.picList.length ? 1 : that.picList.length + 1;
      var _type = that.picList.length ? 1 : 3;
      that.picList = [
        ...that.picList,
        {
          id: new Date().getTime(),
          ImageUrl: "/static/images/noimg.svg",
          type: _type,
          Sort: _sort,
        },
      ];
      that.setPic2Form();
      // var isSize = that.uploadWidth(file);
      if (that.imgCropper) {
        that.getCopper(file);
        return false
      } else {
        return isJPG && isLt5M;//&& isSize;
      }
    },
    uploadWidth(file) {
      //判断上传图片width、height限制
      var that = this;
      const isSize = new Promise(function (resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        console.log(12, _URL)
        let image = new Image();
        image.onload = function () {
          //控制图片上传大小方法
          var _imgWidth = image.width;
          var _imgHeight = image.height;
          //console.log(_imgWidth, _imgHeight);
          let valid = _imgWidth < that.minImgWidth || _imgHeight < that.minImgHeight ? false : true;
          valid ? resolve() : reject();
        };
        image.src = _URL.createObjectURL(file);
      }).then(
        function () {
          //that.uploadFile.append('file', file);
          that.uploadFile = file;
          return file;
        },
        function () {
          that.$message.warning(that.$t('tips.uploadedPicPixels', ['800x600']));
          return Promise.reject();
        }
      );
      return isSize;
    },
    getCopper(file) {
      /* 启用图片裁切 */
      let that = this;
      let fileUrl;
      let f = new FileReader()
      //读取es6格式的图片
      f.readAsDataURL(file)
      //文件读取成功之后把图片赋值给imgbase
      f.onload = function (e) {
        fileUrl = this.result
        that.imgbase = fileUrl
        //开启修改弹框
        that.dislogType = true;
      }
    },
    CopperColse(type) {
      if (type == 'CopperCancel') {
        this.dltImgDiv('last');
      }
      this.dislogType = false;
    },
    NewCos() {
      var that = this;
      //console.log(new Date(new Date().getTime() + 1.5 * 60 * 60 * 1000));
      cos = new COS({
        getAuthorization: function (options, callback) {
          console.log('options:', options)
          // 异步获取临时密钥
          if (that.$cookie.get("cosData")) {
            cosData = JSON.parse(that.$cookie.get("cosData"));
            //console.log("$cookie.get.costoken", cosData);
            var credentials = cosData.Credentials;
            var cb = {
              TmpSecretId: credentials.TmpSecretId,
              TmpSecretKey: credentials.TmpSecretKey,
              SecurityToken: credentials.Token,
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: parseInt(cosData.StartTime), // 时间戳，单位秒，开始时间，即获取时刻的时间戳
              ExpiredTime: parseInt(cosData.ExpiredTime) // 时间戳，单位秒，超时时刻的时间戳
            }
            //console.log("callback",cb);
            callback(cb);
          } else {
            //var url = 'http://world.cardhobby.cn/upload/gettoken';
            that.$get('costoken', "none")
              .then(res => {
                //console.log("costoken", res);
                try {
                  cosData = res;
                  that.$cookie.set("cosData", JSON.stringify(res), { expires: new Date(new Date().getTime() + 1.5 * 60 * 60 * 1000) });
                  //console.log("getAuthorization2 - data", cosData);
                  var credentials = cosData.Credentials;
                } catch (e) {
                }
                if (!cosData || !credentials) {
                  return console.error('credentials invalid:\n' + cosData)
                };
                var cb = {
                  TmpSecretId: credentials.TmpSecretId,
                  TmpSecretKey: credentials.TmpSecretKey,
                  SecurityToken: credentials.Token,
                  // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
                  StartTime: parseInt(cosData.StartTime), // 时间戳，单位秒，开始时间，即获取时刻的时间戳
                  ExpiredTime: parseInt(cosData.ExpiredTime) // 时间戳，单位秒，超时时刻的时间戳
                }
                //console.log("callback",cb);
                callback(cb);
              })
              .catch((err) => {
                console.log(err);
              });
            // var xhr = new XMLHttpRequest();
            // xhr.open('GET', url, true);
            // xhr.onload = function (e) {
            //   //console.log("getAuthorization2", e);
            //   //////////////
            // };
            // xhr.send();
          }
        }
      });
    },
    uploadImg(imgFd) {
      var that = this;
      var uploadType = process.env.NODE_ENV == "development" ? "api" : "cos";//cos api
      //  return;
      var noimg = 0;
      var cosConfig = that.$store.state.cosConfig;
      var _Prefix = cosConfig.Prefix || that.Prefix;
      console.log("uploading_Prefix", _Prefix)
      if (uploadType == "cos") {
        /* COS 传图 */
        var myGuid = Guid.raw();
        // var cosConfig = that.$store.state.cosConfig;
        //console.log("myGuid", myGuid.replace(/-/g, ""), " imgFd:", imgFd);
        var fileType = imgFd.type == 'image/png' ? ".png" : '.jpg';
        var imgKey = _Prefix + myGuid.replace(/-/g, "") + fileType;
        cos.putObject({
          Bucket: cosConfig.Bucket, /* 必须 */
          Region: cosConfig.Region, /* 存储桶所在地域，必须字段 */
          Key: imgKey, /* 必须 */
          Prefix: _Prefix,
          StorageClass: 'STANDARD',
          Body: that.imgCropper ? imgFd : imgFd.file, // 上传文件对象
          Headers: {
            'x-cos-request-id': cosData.RequestId
          },
          onProgress: function (progressData) {
            console.log("onProgress:", JSON.stringify(progressData));
          }
        }, function (err, data) {
          //console.log("err", err);
          //console.log("data", data);
          if (err) {
            //cos 上传失败
            that.$message.error("Photo URL got failed");
            var _picList = that.picList;
            _picList = _picList.filter(function (obj, kk) {
              //console.log(valId, obj.id);s
              if (img['ImageUrl'].indexOf("noimg") > -1) {
                return obj;
              }
            });
            that.picList = _picList;
          } else {
            //cos 上传成功
            that.picList.filter((img, k) => {
              if (img['ImageUrl'].indexOf("noimg") > -1) {
                noimg = k;
              }
            });
            that.picList[noimg]['ImageUrl'] = that.ImagesUrl + imgKey
            that.setPic2Form();
          }
          that.CopperColse();
        });
      } else {
        var fd = new FormData();
        if (that.imgCropper) {
          fd.append('file', imgFd);
        } else {
          fd.append('file', imgFd.file);
        }
        that.axios.post(that.uploadUrl, fd).then((res) => {
          if (res.result) {
            that.picList.filter((img, k) => {
              if (img['ImageUrl'].indexOf("noimg") > -1) {
                noimg = k;
              }
            });
            that.picList[noimg]['ImageUrl'] = res.data
            that.setPic2Form();
          } else {
            console.log(response, file);
            this.$message.error(that.$t('tips.failedImgAddr'));
          }
          that.CopperColse();
        })
      }
    },
    uploadImgSuccess(response, file, fileList) {
      var that = this;
      //console.log('----uploadImgSuccess---');
      if (file.status == "success") {
        var _sort = that.picList.length ? 1 : that.picList.length + 1;
        var _type = that.picList.length ? 1 : 3;
        that.picList = [
          ...that.picList,
          {
            id: new Date().getTime(),
            ImageUrl: file.response.data,
            type: _type,
            Sort: _sort,
          },
        ];
        that.setPic2Form();
      } else {
        console.log(response, file);
        this.$message.error(that.$t('tips.failedImgAddr'));
        //测试
        //that.picList = [...that.picList, { id: new Date().getTime(), url: '/Content/img/thumbA.jpg', type: 1 }]
        //测试
      }
    },
    uploadImgError(err, file, fileList) {
      console.log("----uploadImgError---");
      console.log(err, file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(this.$t('tips.uploadedPicLen', [this.picListLimit]));
      //this.$message.warning(`当前限制选择 5 张，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(this.$t('tips.fileRemove', [file.name]));
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    // 展示图拖曳
    handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd(e, item) {
      this.dragging = null;
    },
    //首先把div变成可以放置的元素，即重写dragenter/dragover
    handleDragOver(e) {
      e.dataTransfer.dropEffect = "move"; // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
    },
    handleDragEnter(e, item) {
      var that = this;
      e.dataTransfer.effectAllowed = "move"; //为需要移动的元素设置dragstart事件
      if (item === this.dragging) {
        return;
      }
      var newItems = [...this.picList];
      //console.log(newItems)
      var src = newItems.indexOf(this.dragging);
      var dst = newItems.indexOf(item);
      newItems.splice(dst, 0, ...newItems.splice(src, 1));

      newItems = newItems.filter(function (obj, key) {
        obj["Sort"] = key + 1;
        if (key <= 0) {
          obj["type"] = 3;
        } else {
          obj["type"] = 1;
        }
        return obj;
      });
      this.picList = newItems;
      that.setPic2Form(); //图片写入FormData
      //console.log("handleDragEnter:FormData:",that.FormData);
    },
    // 展示图拖曳end
    setPic2Form() {
      var that = this;
      that.$set(that.FormData, "NewCommunityImages", that.picList); //图片写入FormData
      if (that.needReturn) {
        that.returnImgs()
      }
    },
    dltImgDiv(id, uploadId, valId, valKey) {
      //console.log("fun dltImgDiv:", id, uploadId, valId, valKey);
      var that = this;
      var _picList = this.picList;
      _picList = _picList.filter(function (obj, kk) {
        //console.log(valId, obj.id);
        if (id == 'last') {
          //删除最后一个
          if (kk != _picList.length - 1) {
            return obj;
          }
        } else {
          if (valId != obj.id) {
            return obj;
          }
        }
      });
      this.picList = _picList;
      that.setPic2Form();
      //deleteImageDiv(id, uploadId);//public.js
    },
    returnImgs() {
      this.$emit('returnImgs', this.picList);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dltImg {
  position: absolute;
  top: 0;
  right: 0;
  width: 18px;
  height: 18px;
}

.dltImg img {
  width: 100%;
  height: auto;
}

.gridly-box {
  width: 100%;
  position: relative;
}

.gridly-box-flex {}

.pic-list-box {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.gridly-item {
  transition: all linear 0.3s;
  margin: 0 10px 5px 0;
  border: 1px solid #f4f4f4;
  display: flex;
  width: 100%;
}

.thumbnail {
  position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0;
  width: 100px;
  height: 100px;
}

.img-url {
  padding: 10px;
  cursor: pointer;
  flex: 1;
}
.text-img-url{
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
}

.card-pic {
  width: 100%;
  height: auto;
}

.up-img-btn {
  cursor: pointer;
  width: 100px;
  height: 100px;
  display: flex;
  align-content: center;
  align-items: center;
  border: 1px dashed #ededed;
  border-radius: 4px;
  color: #a0a0a0;
  font-size: 14px;
  flex-direction: column;
  justify-content: center;
  margin: 0 0 20px;
}

.up-img-btn:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100%;
  line-height: 100px;
  text-align: center;
}

.up-img-btn img {
  width: 100%;
}

.send_box .up-img-btn img {
  width: 100%;
}

/* input[type="file"].el-upload__input {
  display: none;
} */
.gridly-box .el-upload.el-upload--picture {
  width: 100%;
  height: 100%;
}

.el-icon-plus {
  font-size: 32px;
}

/* small style*/
.gridly-box-small .up-img-btn {
  width: 25px;
  height: 25px;
}

.gridly-box-small .gridly-item {
  width: 50px;
  height: 50px;
}

.gridly-box-small .dltImg {
  width: 12px;
  height: 12px;
}

.gridly-box-small .pic-list-box {
  position: absolute;
  top: -300%;
  background: rgba(255, 255, 255, 0.6);
  width: 99%;
  padding: 5px 0;
  left: -1%;
  z-index: 2;
}

.gridly-box-small .dltImg {
  display: none;
}

.gridly-box-small .gridly-item:hover .dltImg {
  display: block;
}

.flexCol {
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/upload-images-cos.vue